
export enum TabStatus {
	Error = 'error',
	Loaded = 'loaded',
	Loading = 'loading',
}

export interface AttendantsResponse {
	count: number
	users: User[]
}

export interface User {
	email: string;
	firstName: string;
	lastName: string;
	lnLong: string;
	secondaryEmail: string;
	userId: string;
}
export interface TableData {
	conference: string;
	email: string;
	key: string
	name: string;
	secondaryEmail: string;
}

